<template>
    <ListViewer v-if="true" idName="list23" className="list23 m-0" listLayout="flow" :data="items">
        <template v-slot:default="itemData">
            <div id="card24" class="customer-card">
                <CardViewer className="card24 p-0">
                    <div id="card25">
                        <CardViewer className="card25">
                            <TextViewer idName="text27" :value="(itemData.data.code != undefined ? itemData.data.code : '-')" className="text27" />
                        </CardViewer>
                    </div>
                    <div id="card19">
                        <CardViewer className="card19">
                            <TextViewer idName="text21" :value="roundNumber((itemData.data.minesItem != undefined ? itemData.data.minesItem : 0), 0) + ' ITEM'" className="text21" />
                        </CardViewer>
                    </div>
                </CardViewer>
            </div>
        </template>
    </ListViewer>
</template>
<style scoped lang="scss">
    @import '../../../assets/dashboardcss/andonwip.scss';
</style>
<script>
import { thousandSeparator } from '@/utils/thousandSeparator';
import RowViewer from '@/components/dashboard/RowViewer';
import ColumnViewer from '@/components/dashboard/ColumnViewer';
import CardViewer from '@/components/dashboard/CardViewer';
import TextViewer from '@/components/dashboard/TextViewer';
import ListViewer from '@/components/dashboard/ListViewer';
import TableViewer from '@/components/dashboard/TableViewer';

export default {
    props: {
        items : {
            default: function() { return []; },
            type: Array,
        }
    },
    data() {
        return {
            cssLinkElement: "",
            cssLoaded : false,
        }
    },
    components: {
		RowViewer, ColumnViewer, CardViewer, TextViewer, ListViewer, TableViewer
	},
    mounted() {
        this.loadStyles();
    },
    watch : {
        items : {
            handler() {
                this.loadStyles();
            },
            deep: true
        }
    },
    methods: {
        roundNumber(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
		},
        changeNumber() {
            document.documentElement.style.setProperty('--default-item', this.items.length);
        },
        loadStyles() {
            if (this.items.length <= 0) return;
            this.removeStyles();
            this.loadExternalCSS(process.env.VUE_APP_API_URL + `datasource/generatecss?n=` + this.items.length)
                .then((linkElement) => {
                    this.cssLinkElement = linkElement;
                    this.cssLoaded = true;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        removeStyles() {
            if (this.cssLinkElement) {
                document.head.removeChild(this.cssLinkElement);
                this.cssLinkElement = null;
            }
        },
        loadExternalCSS(url) {
            return new Promise((resolve, reject) => {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = url;
                link.onload = () => resolve();
                link.onerror = () => reject(new Error(`Failed to load stylesheet from ${url}`));
                document.head.appendChild(link);
            });
        }
    }

}
</script>